<template>
  <div class="flood-hazard">
    <the-top-bar title="Flood Hazard Assessment" />
    <survey-overview @updateStep="$_goToSection" v-if="currentStep === 0" />
    <div class="row">
      <div class="app-form">
        <form-builder ref="loanForm" :schema="schema" v-model="form" :stepper-data="stepper" @status="saveStatus"
          @stepStatus="updateStepStatus" :current-step="currentStep" isStepper v-if="ready" />
      </div>

    </div>
    <!--   <div
      class="score-overview shadow-depth"
      id="v-step-1"
      :class="[scoreOverviewColorX]"
      v-if="currentStep < 3 && currentStep > 0"
    >
      {{ impactLevel }}
    </div> -->
    <div class="control-bar z-depth-1 row" v-if="currentStep > 0">
      <button class="btn btn-flat waves-effect btn-rounded white black-text col s5 m2" @click="$_goTo('overview')">
        Back
      </button>
      <router-link class="btn waves-effect btn-rounded col s5 m2 right" style="background:#5374F8; color:#fff;"
        v-if="currentStep === 3" :to="{ name: 'Home' }">
        Finish
      </router-link>

      <button class="btn waves-effect btn-rounded col s5 m2 right" style="background:#5374F8; color:#fff;"
        :class="[status.invalid ? 'disabled' : 'shadow-depth']" @click="$_goTo()" v-if="currentStep < 3">
        Next
      </button>
    </div>
    <app-bottom-tab v-else />
    <final-step v-if="currentStep === 3" :data-impact-level="impactLevel" @updateSelectedScore="$_updateScore"
      :dataSelectedScore="floodHazardSurvey ? floodHazardSurvey.score : {}" dataSurvey="flood_survey" />
  </div>
</template>

<script>
import FormBuilder from "@/components/formBuilder/FormBuilder.vue";
import { schema, impactLevelGenerator } from "@/schemas/floodHazard.js";
import TheTopBar from "@/components/TheTopBar";
import { mapActions, mapState } from "vuex";
import FinalStep from "@/components/TheSurveyFinalStep";
import { setDocumentBodyOverflowProperty } from "@/common/util";
import { createSurvey, updateSurvey } from "@/api/survey.api";
import TheSurveysTour from "@/components/TheSurveysTour";
import SurveyOverview from "@/components/FloodSurvey/SurveyOverview";
import AppBottomTab from "@/components/AppBottomTab";
export default {
  name: "FloodHazardSurvey",
  components: {
    FormBuilder,
    TheTopBar,
    FinalStep,
    TheSurveysTour,
    SurveyOverview,
    AppBottomTab,
  },
  data() {
    return {
      schema,
      ready: false,
      status: {
        invalid: false,
      },
      form: {},
      currentStep: 0,
      stepper: {
        stepStatus: false,
        canPrev: false,
        canNext: false,
      },
      impactLevel: "",

      shouldSave: false,
      userSelectedScore: "",
      userJustification: "",
      tagId: 39,
      section: "",
    };
  },

  beforeRouteLeave(to, from, next) {
    // if (navigator.onLine) this.$_saveDataToCould();
    if (
      to.name === "FloodHazard" &&
      this.$store.state.Surveys.floodHazardStarted
    ) {
      next({ name: "Home" });
    }
    next();
  },
  created() {
    // Redirect user to survey start page if user hasnt started survey
    if (!this.$store.state.Surveys.floodHazardStarted) {
      this.$router.push({ name: "FloodHazard" });
    }
  },
  mounted() {
    // this.$_getStepFromUrl();
    this.$_getData();
  },
  watch: {
    $route: function (nV) {
      if (nV && !nV.query || nV && !nV.query.editing) {
        this.$_goTo(1)
      } else if (nV && nV.query.editing) {

      }
    },
    currentStep: function (nV) {
      nV < 1 && this.$route.query.editing
        ? this.$router.replace({ query: {} })
        : ''
    }
  },

  computed: {
    ...mapState({
      showTour: (state) => state.Surveys.showSurveyTour,
      floodHazardSurvey: (state) => state.Surveys.floodHazard,
      floodHazardStarted: (state) => state.Surveys.floodHazardStarted,
      user: (state) => state.User.user,
    }),

    scoreOverviewColorX() {
      switch (this.impactLevel) {
        case "Minor":
          return "light-blue-text lighten-3";
        case "Moderate":
          return "amber-text lighten-2";
        case "Major":
          return "orange-text lighten-3";
        case "Extreme":
          return "red-text lighten-3";
        default:
          return "black-text";
      }
    },
    surveyDataX() {
      return {
        survey: this.form,
        score: {
          generated: this.impactLevel,
          selected: this.userSelectedScore,
          justification: this.userJustification,
        },
        assessment: this.floodHazardSurvey && this.floodHazardSurvey.assessment ? this.floodHazardSurvey.assessment : {}
      };
    },
  },
  methods: {
    ...mapActions("Surveys", {
      setShowSurveyTour: "SET_SHOW_SURVEY_TOUR",
      updateSurvey: "UPDATE_FLOOD_HAZARD",
    }),
    $_setupHelpers() {
      const helpers = this.$el.querySelectorAll("[helper-id]");

      if (helpers) {
        helpers.forEach((helperEl) => {
          helperEl.addEventListener("click", (event) => {
            event.preventDefault();
            const helperId = helperEl.getAttribute("helper-id");
            this.$store.dispatch("Helpers/setHelper", helperId);
          });
        });
      }
    },
    $_updateScore(val) {
      this.userSelectedScore = val.selected;
      this.userJustification = val.justification;
      this.$_saveData();
    },
    $_getData() {
      if (this.floodHazardSurvey) {
        this.form = this.floodHazardSurvey.survey;
        this.userSelectedScore = this.floodHazardSurvey.score.selected;
        this.userJustification = this.floodHazardSurvey.score.justification;
      }
      this.ready = true;
      setTimeout(() => {
        this.$_setupHelpers();
      }, 300);
    },
    $_goTo(step = null) {
      if (this.shouldSave) this.$_saveData();
      if (step) {
        this.currentStep = 0;
      } else {
        if (this.section === "exposure_flooding") {
          this.currentStep = 2;
          this.section = "vulnerability_flooding";
        } else if (this.section === "vulnerability_flooding")
          this.currentStep = 3;
        setTimeout(() => {
          this.$_setupHelpers();
        }, 300);
      }
      window.scrollTo(0, 0);
    },
    $_endTour() {
      this.setShowSurveyTour(false);
      setDocumentBodyOverflowProperty("auto");
    },
    $_saveDataToCould() {
      if (this.floodHazardSurvey) {
        if (this.floodHazardSurvey.id) {
          const payload = {
            fields: {
              survey_data: JSON.stringify(this.floodHazardSurvey),
            },
          };
          updateSurvey(this.floodHazardSurvey.id, payload)
            .then((res) => { })
            .catch((err) => {
              // Better erorr handling
              console.log(err);
              if (err.response.data) {
                console.log(err.response.data);
              }
            });
        } else {
          const payload = {
            title: `${this.user.slug}-FloodHazard`,
            author: this.user.id,
            status: "publish",
            tags: [this.tagId],
            content: `${this.user.slug}-FloodHazard`,
            fields: {
              survey_data: JSON.stringify(this.floodHazardSurvey),
            },
          };

          createSurvey(payload)
            .then((res) => {
              const surveyData = JSON.parse(res.data.acf.survey_data);
              surveyData.id = res.data.id;
              this.updateSurvey(surveyData);
            })
            .catch((err) => {
              // Better erorr handling
              console.log(err);
              if (err.response.data) {
                console.log(err.response.data);
              }
            });
        }
      }
    },

    $_goToSection({ step, section }) {
      this.currentStep = step;
      this.section = section;
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.$_setupHelpers();
      }, 300);
    },
    saveStatus(status) {
      Object.assign(this.status, status);
      this.getImpactLevel();
    },
    submit() {
      this.$refs.loanForm.validate();
      if (this.status.invalid) return;
    },
    updateStepStatus(stepInfo) {
      Object.assign(this.stepper, stepInfo);
      if (!stepInfo.isInitializing) this.shouldSave = true;
    },
    getImpactLevel() {
      this.impactLevel = impactLevelGenerator(this.schema, this.form);
    },
    $_next(step) {
      if (step === "final") {
        this.$_saveData();
      }
      if (step === "finish") {
        this.$router.push({ name: "Home" });
      }
      this.currentStep++;
      window.scrollTo(0, 0);
    },
    $_prev() {
      this.currentStep--;
      window.scrollTo(0, 0);
    },
    $_saveData() {
      // if (this.isFirstime) return;
      // if (this.floodHazardSurvey) {
      //   if (this.floodHazardSurvey.id) {
      //     this.surveyDataX.id = this.floodHazardSurvey.id;
      //   }
      // }
      this.updateSurvey(this.surveyDataX);
      // this.shouldSave = false;
    },
  },
};
</script>

<style lang="scss">
.flood-hazard {
  padding-bottom: 68px;

  .app-form {
    padding: 16px 24px 0 24px;
    max-width: 768px;
    margin: auto;
  }

  .section-head {
    font-size: 32px;
    font-family: "Libre Franklin", sans-serif;
    line-height: 34px;
    font-weight: 600;
    color: #F6BE22;
  }

  .control-bar {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 60px;
    width: 100%;
    padding: 1rem;
    margin: 0 !important;
    background: #fff;
    z-index: 900;
  }


}
</style>

<style>
/* .btn-save {
  position: fixed;
  top: 68px;
  right: 2rem;
  background: #5374f8;
} */
</style>
